import React from 'react';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '',
  children, 
  onClick,
  type = 'button',
  disabled = false
}) => {
  const baseClasses =
    'rounded-full font-bold transition-colors duration-200 inline-flex items-center justify-center gap-2 min-h-11 md:min-h-0';
  
  const variantClasses = {
    primary: 'bg-accent-strong text-white hover:bg-accent-hover',
    secondary: 'bg-surface-2 text-fg border border-line hover:border-line-strong',
    outline: 'bg-transparent border border-line-strong text-fg hover:border-fg-subtle hover:bg-white/[0.04]'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-[15px]',
    lg: 'px-6 py-3 text-[15px]'
  };
  
  const cursorClass = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${cursorClass} ${className}`;
  
  return (
    <button 
      className={classes} 
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
};